<div class="tryb-input-container">
    <label *ngIf="inputLabel !== ''" [for]="inputLabel" class="input-label">
        {{ inputLabel }}
    </label>
    <div
        class="input-wrapper d-flex align-items-center"
    >
        <div class="position-relative">
            <div
                class="tryb-dropdown"
                [ngClass]="{disabled: control.disabled}"
            >
                <select
                    [id]="inputLabel"
                    [formControl]="control"
                    (change)="onValueChange()"
                >
                    <option
                        *ngFor="let option of options"
                        [value]="option.value"
                        [id]="option.value"
                    >
                        {{ option.label }}
                    </option>
                </select>
            </div>
        </div>
    </div>
</div>
